import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowRight } from 'lucide-react';
import { navigationLinks } from '../../data/mock';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href) => {
    setIsMobileMenuOpen(false);
    if (href.startsWith('/#')) {
      const element = document.getElementById(href.substring(2));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <>
      <header
        className="nav-header"
        style={{
          background: isScrolled ? 'rgba(0, 0, 0, 0.95)' : 'rgba(0, 0, 0, 0.8)',
        }}
      >
        <Link to="/" className="nav-logo">
          Naabu<span>.</span>
        </Link>

        <nav className="nav-links">
          {navigationLinks.map((link) => (
            <Link
              key={link.name}
              to={link.href}
              className="nav-link"
              style={{
                color: location.pathname === link.href ? '#f06a15' : undefined
              }}
              onClick={(e) => {
                if (link.href.startsWith('/#') && location.pathname === '/') {
                  e.preventDefault();
                  handleNavClick(link.href);
                }
              }}
            >
              {link.name}
            </Link>
          ))}
        </nav>

        <Link to="/coming-soon" className="nav-cta">
          <span>Pre-register</span>
          <ArrowRight size={16} />
        </Link>
        <button
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          style={{
            position: 'fixed',
            top: '80px',
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.98)',
            backdropFilter: 'blur(20px)',
            zIndex: 99,
            padding: '40px 5%',
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
          }}
        >
          {navigationLinks.map((link) => (
            <Link
              key={link.name}
              to={link.href}
              onClick={(e) => {
                if (link.href.startsWith('/#') && location.pathname === '/') {
                  e.preventDefault();
                  handleNavClick(link.href);
                } else {
                  setIsMobileMenuOpen(false);
                }
              }}
              style={{
                color: location.pathname === link.href ? '#f06a15' : 'white',
                textDecoration: 'none',
                fontSize: '24px',
                fontWeight: 600,
              }}
            >
              {link.name}
            </Link>
          ))}
          <Link
            to="/coming-soon"
            className="btn-primary"
            style={{ marginTop: '20px', width: '100%', justifyContent: 'center', display: 'flex' }}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <span>Pre-register</span>
            <ArrowRight size={18} />
          </Link>
        </div>
      )}
    </>
  );
};

export default Navigation;
